import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import './react-datepicker.less';
import './customDatePicker.styles.less';

class DatePickerWithFocusInputCancelled extends DatePicker {
  /**
   * this fixes react-datepicker issue with input forced focus
   */
  deferFocusInput = () => {
    this.cancelFocusInput();
  };
}

class CustomDatePicker extends React.PureComponent {

  static propTypes = {
    ...DatePicker.propTypes,
    popperClass: PropTypes.string,
    timeZone: PropTypes.string.isRequired
  };

  static defaultProps = {
    ...DatePicker.defaultProps,
    popperClass: 'date-picker-range-wrapper'
  };

  momentToDate = (momentObject) => {
    if (momentObject) {
      return momentObject.toDate();
    }
    return null;
  };

  convertToTimeZone = (momentObj) => {
    if (momentObj.tz() === this.props.timeZone) {
      return momentObj.clone();
    }
    return momentObj.clone().tz(this.props.timeZone, true);
  };

  onChangeHandler = (momentObj, event) => {
    const changedDateInProperTimeZone = this.convertToTimeZone(momentObj);
    this.props.onChange(changedDateInProperTimeZone, event);
  };

  render() {
    // noinspection JSUnusedLocalSymbols
    const { onChange, timeZone, ...restProps } = this.props;

    return (
      <DatePicker
        {...restProps}
        onChange={this.onChangeHandler}
        selected={this.momentToDate(this.props.selected)}
        minDate={this.momentToDate(this.props.minDate)}
        maxDate={this.momentToDate(this.props.maxDate)}
      />
    );

    // const popperContainer = ({ children }) => children ? (
    //   ReactDOM.createPortal(React.cloneElement(children, {
    //     className: `${this.props.popperClass} react-datepicker-popper`
    //   }), document.body)
    // ) : null;
    //
    // return (<DatePickerWithFocusInputCancelled
    //   {...restProps}
    //   onChange={this.onChangeHandler}
    //   popperContainer={popperContainer}
    // />);
  }
}

export default CustomDatePicker;
